export default "__VITE_ASSET__26s04gIv__"